import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import useClasses from "../useClasses";

const styles = (theme) => ({
  icon: {
    alignSelf: "flex-start",
    color: "blue",
  },
  secondaryButton: {
    color: theme.palette.text.secondary,
  },
});

const isValid = (str) => {
  if (!str.replace(/\s/g, "").length) {
    //string only contains whitespace (ie. spaces, tabs or line breaks)
    return false;
  } else {
    return true;
  }
};

function RenameDialog(props) {
  const {
    open,
    setOpen,
    renameFunction,
    input,
    errorFunction = () => false,
    helperText,
    dialogTitle,
    dialogContentText,
    dialogActionCancel,
    dialogActionConfirm,
  } = props;
  const classes = useClasses(styles);
  const [inputValue, setInputValue] = useState("");

  const handleClose = () => {
    setOpen((prev) => ({ ...prev, open: false }));
  };

  const handleEnter = () => {
    setInputValue(input);
  };

  const handleInputValue = (event) => {
    setInputValue(event.target.value);
  };

  const handleSave = () => {
    renameFunction(inputValue);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="rename-dialog"
      fullWidth={true}
      maxWidth="sm"
      sx={{ maxWidth: "sm", margin: "auto" }}
      TransitionProps={{
        onEnter: handleEnter,
      }}
    >
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{dialogContentText}</Typography>
        <div style={{ padding: 8 }} />
        <TextField
          error={errorFunction(inputValue)}
          helperText={errorFunction(inputValue) ? helperText : ""}
          style={{ width: "100%" }}
          autoFocus
          value={inputValue}
          onChange={handleInputValue}
          color="primary"
          onKeyDown={(e) => {
            if (
              e.code === "Enter" &&
              isValid(inputValue) &&
              !errorFunction(inputValue)
            ) {
              handleSave();
            }
          }}
        />
      </DialogContent>

      <DialogActions>
        <Box>
          <Button onClick={handleClose} className={classes.secondaryButton}>
            {dialogActionCancel}
          </Button>
        </Box>
        <Box>
          <Button
            onClick={handleSave}
            disabled={!isValid(inputValue) || errorFunction(inputValue)}
            color="primary"
          >
            {dialogActionConfirm}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}

export default RenameDialog;
